import {
  removeProject,
  getAllProjects,
  getProjects,
  shareProjectInMinervaNet,
  unshareProjectInMinervaNet,
  archiveProject,
  reviveProject,
} from '@/redux/projects/projects.thunks';
import { ProjectsState } from '@/redux/projects/projects.types';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

export const getProjectsReducer = (builder: ActionReducerMapBuilder<ProjectsState>): void => {
  builder.addCase(getProjects.pending, state => {
    state.loading = 'pending';
  });
  builder.addCase(getProjects.fulfilled, (state, action) => {
    state.data = action.payload || undefined;
    state.loading = 'succeeded';
  });
  builder.addCase(getProjects.rejected, state => {
    state.loading = 'failed';
  });

  builder.addCase(getAllProjects.pending, state => {
    state.loading = 'pending';
  });
  builder.addCase(getAllProjects.fulfilled, (state, action) => {
    state.data = action.payload || undefined;
    state.loading = 'succeeded';
  });
  builder.addCase(getAllProjects.rejected, state => {
    state.loading = 'failed';
  });
};

export const removeProjectReducer = (builder: ActionReducerMapBuilder<ProjectsState>): void => {
  builder
    .addCase(removeProject.pending, state => {
      state.loading = 'pending';
      state.error = { name: '', message: '' };
    })
    .addCase(removeProject.fulfilled, (state, action: PayloadAction<string>) => {
      state.loading = 'succeeded';
      state.data = state.data.filter(project => project.projectId !== action.payload);
    })
    .addCase(removeProject.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = { name: 'Remove Error', message: action.payload || 'Unknown error occurred' };
    });
};

export const shareProjectReducer = (builder: ActionReducerMapBuilder<ProjectsState>): void => {
  builder
    .addCase(shareProjectInMinervaNet.fulfilled, (state, action: PayloadAction<string>) => {
      const project = state.data.find(p => p.projectId === action.payload);
      if (project) {
        project.sharedInMinervaNet = true;
      }
    })
    .addCase(unshareProjectInMinervaNet.fulfilled, (state, action: PayloadAction<string>) => {
      const project = state.data.find(p => p.projectId === action.payload);
      if (project) {
        project.sharedInMinervaNet = false;
      }
    });
};

export const archiveProjectReducer = (builder: ActionReducerMapBuilder<ProjectsState>): void => {
  builder
    .addCase(archiveProject.pending, state => {
      state.loading = 'pending';
      state.error = { name: '', message: '' };
    })
    .addCase(archiveProject.fulfilled, (state, action) => {
      state.loading = 'succeeded';
      const project = state.data.find(p => p.projectId === action.payload);
      if (project) {
        project.status = 'Archived';
      }
    })
    .addCase(archiveProject.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = {
        name: 'Archive Error',
        message: action.payload || 'Failed to archive project',
      };
    });
};

export const reviveProjectReducer = (builder: ActionReducerMapBuilder<ProjectsState>): void => {
  builder
    .addCase(reviveProject.pending, state => {
      state.loading = 'pending';
      state.error = { name: '', message: '' };
    })
    .addCase(reviveProject.fulfilled, (state, action) => {
      state.loading = 'succeeded';
      const project = state.data.find(p => p.projectId === action.payload);
      if (project) {
        project.status = 'Ok';
      }
    })
    .addCase(reviveProject.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = { name: 'Revive Error', message: action.payload || 'Failed to revive project' };
    });
};
